import React from 'react';
import { COLORS } from '@constants';
import { Typography } from '@ui';
import { StyledImage, StyledWrapper } from './styled';

const Card = ({ info, type }) => {
    const isHomePage = type === 'homepage';

    return (
        <StyledWrapper $isHomePage={isHomePage} data-e2e='top-sites_site_card'>
            <StyledImage $isHomePage={isHomePage} src={info?.logoSrc} alt={info?.name} data-e2e='top-sites_site_logo' />
            <Typography.Text type='badgeMedium' color={COLORS.$gray40Black} data-e2e='top-sites_site-name_value'>
                {info?.name}
            </Typography.Text>
        </StyledWrapper>
    );
};

export default Card;
